import React from 'react';
import { FocusRing } from '@react-aria/focus';
import PropTypes from 'prop-types';
import ArrowUp from '../../../shared/icons/icon-arrow-up.svg';
import ArrowDown from '../../../shared/icons/icon-arrow-down.svg';
import isEnterOrSpace from '../../../shared/helpers/isEnterOrSpace';


const Toggler = function TogglerComponent({ isExpanded, action }) {
  const buttonText = isExpanded ? 'Hide some comparisons' : 'Show some comparisons';
  const ArrowIcon = isExpanded ? ArrowUp : ArrowDown;
  const handleKeyUp = event => isEnterOrSpace(event.key) && action();

  return (
    <div className="product-table__button-holder">
      <FocusRing focusRingClass="product-table__button--focused">
        <button
          className="product-table__button"
          type="button"
          onKeyUp={handleKeyUp}
          onClick={action}
          aria-expanded={isExpanded}
        >
          {`${buttonText} `}
          <ArrowIcon className="product-table__arrow-icon" />
        </button>
      </FocusRing>
    </div>
  );
};

Toggler.propTypes = {
  isExpanded: PropTypes.bool.isRequired,
  action: PropTypes.func.isRequired,
};

export default Toggler;
